"use client";

import cn from "@utils/cn";
import Image from "next/image";
import Link from "next/link";
import { FC, useEffect, useState } from "react";

import Button, { ButtonSize, ButtonTheme, ButtonVariant } from "@/components/ui/Button/Button";
import useMediaQuery from "@/hooks/useMediaQuery";
import { FeatureListProps } from "@/types";

const FeatureList: FC<FeatureListProps> = ({ entry }) => {
  const isDesktop = useMediaQuery("(min-width: 1025px)");
  const isTablet = useMediaQuery("min-width: 768px");
  const isMobile = useMediaQuery("(max-width: 1023px)");
  return (
    <div className="px-m md:px-0">
      <div
        className={cn(
          "md:mx-auto rounded-2xl py-[40px] md:px-[40px] text-center",
          entry?.backgroundToggle && "bg-white  shadow-extra-strong",
          isTablet && "w-22\\/24",
          isDesktop && "w-20\\/24",
        )}
      >
        {entry?.title && <h2 className={cn(entry?.titleVariant ? "text-xl" : "text-l", "font-primary uppercase mb-l")}>{entry.title}</h2>}
        {entry?.text && <p className="md:w-[50%] md:m-auto font-secondary font-secondary-light text-[16px] mt-l">{entry.text}</p>}
        {entry?.cta && (
          <Button
            href={entry.cta.link.url}
            size={ButtonSize.MEDIUM}
            theme={ButtonTheme.BLACK}
            type="button"
            variant={ButtonVariant.PRIMARY}
            customClass="inline-flex mt-l mb-l"
          >
            {entry.cta.label}
          </Button>
        )}
        <div className="flex flex-wrap justify-center mt-[40px] gap-xs md:gap-l">
          {entry?.baseElements?.map((item, i) => {
            const Tag = item.cardLink?.link.url ? "a" : "div";
            const isLastOddMobile = isMobile && i === entry.baseElements.length - 1 && i % 2 === 0;
            return (
              <Tag
                key={i}
                {...(item.cardLink && { href: item.cardLink.link.url })}
                className={cn(
                  "bg-gray-7 rounded-lg h-auto w-[calc(50%-4px)] md:w-[calc(20%-24px)] last:odd:w-full md:last:odd:w-[calc(20%-24px)] last:odd:justify-center flex flex-col pt-m pb-m last:odd:px-m",
                  entry.shadowToggle && " shadow-strong",
                )}
              >
                {item.overtitle && <div className="font-primary text-xs uppercase mb-m">{item.overtitle}</div>}
                {item.image && (
                  <div className="w-full mb-m pt-m">
                    <Image
                      className={cn("inline-flex object-contain mx-auto", !item.title && "w-full")}
                      src={item.image.url}
                      alt={item.image.title || ""}
                      width={item.image.width}
                      height={item.image.height}
                    />
                  </div>
                )}
                {item.title && (
                  <div className="font-primary text-s uppercase font-medium text-center mb-xs sm:px-l md:px-0 px-xs break-words hyphens-auto">
                    {item.title}
                  </div>
                )}
                {item.subtitle && <div className={cn("font-secondary text-xs text-center", !isLastOddMobile && "mt-auto")}>{item.subtitle}</div>}
              </Tag>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default FeatureList;
